
import { Component, Vue, Watch } from "vue-property-decorator";
import moment from "moment";

@Component({
  components: {
    SortBox: () => import("@/components/SortBox.vue"),
    Slick: () => import("vue-slick"),
    Modal: () => import("@/components/Modal.vue")
  },
  computed: {
    countries_branches_by_country() {
      return (this as any).countries_branches.filter((cb: any) => {
        return cb.countryId === (this as any).countryId && cb.branch != null;
      });
    }
  }
})
export default class GeneralsIndex extends Vue {
  countries_branches: any = [];
  parameters: any = [];
  countries: any = [];
  countryId: number = 0;

  exchangesDate: Record<string, any> = {};
  sortColumns: Record<string, string> = {
    0: "Impuestos por Ramo",
    1: "Parámetro"
  };
  slickOptions: Record<string, any> = {
    slidesToShow: 1,
    centerPadding: 0,
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          arrows: false,
          dots: false
        }
      }
    ]
  };
  isMobile: boolean = window.innerWidth < 992;
  firstLoad: boolean = true;

  @Watch("isMobile")
  onIsMobileChange(val: boolean, old: boolean) {
    if (this.firstLoad && old === true) {
      this.firstLoad = false;
    } else {
      location.reload();
    }
  }

  handleAfterChange(event, slick, currentSlide) {
    (this.$refs.sortBox as any).update(currentSlide);
  }

  async init() {
    await this.loadCountries();
    await this.loadParameters();
    await this.loadCountriesBranches();
    window.addEventListener("resize", () => {
      this.isMobile = window.innerWidth < 992;
    });
  }

  async loadCountries() {
    const response: any = await (this.$root as any)._get("countries/all");
    this.countries = response.data;
    this.countryId = this.countries[0].id;
  }

  async loadParameters() {
    const response: any = await (this.$root as any)._get("parameters/all");
    this.parameters = response.data;
  }

  async loadCountriesBranches() {
    const response: any = await (this.$root as any)._get("countriesbranches");
    this.countries_branches = response.data;
  }

  async updateCountryBranch(obj: any) {
    try {
      await (this.$root as any)._post("countriesbranches", obj);
      (this.$root as any).notify("Se realizo la actualización con éxito.");
    } catch (e) {
      (this.$root as any).notify("No se pudo actualizar el ramo.", "error");
    }
  }

  async updateParameter(obj: any) {
    try {
      await (this.$root as any)._put(`parameters/${obj.id}`, obj);
      (this.$root as any).notify("Se realizo la actualización con éxito.");
    } catch (e) {
      (this.$root as any).notify("No se actualizar el parametro.", "error");
    }
  }

  async updateCountry(obj: any) {
    try {
      await (this.$root as any)._put(`countries/${obj.id}`, obj);
      (this.$root as any).notify("Se realizo la actualización con éxito.");
    } catch (e) {
      (this.$root as any).notify("No se pudo actualizar el país.", "error");
    }
  }

  move(index) {
    (this.$refs.slick as any).goTo(index);
  }
}
